import { toast } from "sonner";

const INVALID_ATTRIBUTE = "data-admin-invalid";
const INVALID_CLASSES = [
  "!border-red-500",
  "!bg-red-50",
  "!outline-none",
  "ring-2",
  "ring-red-300",
];

const selectorForTestId = (testId) => `[data-testid="${testId}"]`;

const clearMarkedElement = (element) => {
  element.removeAttribute(INVALID_ATTRIBUTE);
  element.removeAttribute("aria-invalid");
  element.classList.remove(...INVALID_CLASSES);
};

const getFocusTarget = (element) => {
  if (element.matches("input, select, textarea, button")) {
    return element;
  }

  return element.querySelector("input, select, textarea, button");
};

const getVisualTarget = (element) => {
  if (element.matches("input, select, textarea, button")) {
    return element;
  }

  return element.querySelector("[class*='border']") || element;
};

const markElement = (element) => {
  const visualTarget = getVisualTarget(element);
  const focusTarget = getFocusTarget(element);
  const marked = [element, visualTarget, focusTarget].filter(Boolean);

  marked.forEach((target) => {
    target.setAttribute(INVALID_ATTRIBUTE, "true");
    target.setAttribute("aria-invalid", "true");
    target.classList.add(...INVALID_CLASSES);
  });

  return focusTarget || visualTarget;
};

const focusMarkedElement = (element) => {
  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  window.setTimeout(() => {
    if (typeof element.focus === "function") {
      element.focus({ preventScroll: true });
    }
  }, 250);
};

export const clearAdminValidationErrors = () => {
  document.querySelectorAll(`[${INVALID_ATTRIBUTE}="true"]`).forEach(clearMarkedElement);
};

export const clearAdminValidationError = (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) {
    return;
  }

  let current = target;
  while (current) {
    if (current.getAttribute(INVALID_ATTRIBUTE) === "true") {
      clearMarkedElement(current);
    }
    current = current.parentElement;
  }
};

export const showAdminFieldErrors = (message, testIds) => {
  clearAdminValidationErrors();
  const elements = testIds
    .map((testId) => document.querySelector(selectorForTestId(testId)))
    .filter(Boolean);
  const focusTarget = elements.map(markElement)[0];

  toast.error(message);
  focusMarkedElement(focusTarget);
};

export const handleAdminNativeInvalid = (event) => {
  event.preventDefault();
  const target = event.target;
  if (!(target instanceof HTMLElement)) {
    return;
  }

  clearAdminValidationErrors();
  const focusTarget = markElement(target);
  const fieldLabel = target.closest("label")?.innerText?.split("\n")[0] || "required field";
  toast.error(`Please complete the highlighted ${fieldLabel}.`);
  focusMarkedElement(focusTarget);
};